var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 451,
    height: 451,
    viewBox: "0 0 451 451",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M193.253 135.976H117.034V392.595H193.253V135.976Z",
    fill: "#C6E9FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M193.253 135.976H117.034V392.595H193.253V135.976Z",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M280.973 135.976H190.773V392.595H280.973V135.976Z",
    fill: "#0077AF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M280.973 135.976H190.773V392.595H280.973V135.976Z",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.134 177.92L143.418 170.479L147.703 162.812H156.497H165.292L169.576 170.479L173.861 177.92L169.576 185.587L165.292 193.029H156.497H147.703L143.418 185.587L139.134 177.92Z",
    fill: "#0077AF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M139.134 177.92L143.418 170.479L147.703 162.812H156.497H165.292L169.576 170.479L173.861 177.92L169.576 185.587L165.292 193.029H156.497H147.703L143.418 185.587L139.134 177.92Z",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.398 178.145L138.682 170.478L143.192 163.036H151.761H160.556L164.84 170.478L169.35 178.145L164.84 185.586L160.556 193.253H151.761H143.192L138.682 185.586L134.398 178.145Z",
    fill: "#C6E9FA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M134.398 178.145L138.682 170.478L143.192 163.036H151.761H160.556L164.84 170.478L169.35 178.145L164.84 185.586L160.556 193.253H151.761H143.192L138.682 185.586L134.398 178.145Z",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.584 342.987L143.869 335.546L148.153 327.879H156.948H165.517L170.027 335.546L174.311 342.987L170.027 350.654L165.742 358.096H156.948H148.153L143.869 350.654L139.584 342.987Z",
    fill: "#0077AF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M139.584 342.987L143.869 335.546L148.153 327.879H156.948H165.517L170.027 335.546L174.311 342.987L170.027 350.654L165.742 358.096H156.948H148.153L143.869 350.654L139.584 342.987Z",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.398 342.987L138.682 335.546L143.192 327.879H151.761H160.556L164.84 335.546L169.35 342.987L164.84 350.654L160.556 358.096H151.761H143.192L138.682 350.654L134.398 342.987Z",
    fill: "#C6E9FA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M134.398 342.987L138.682 335.546L143.192 327.879H151.761H160.556L164.84 335.546L169.35 342.987L164.84 350.654L160.556 358.096H151.761H143.192L138.682 350.654L134.398 342.987Z",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M211.97 135.977C211.97 136.428 206.783 136.428 206.783 135.977C206.783 133.722 206.783 131.918 206.783 129.663C206.783 127.408 206.783 124.928 206.783 122.673C206.783 119.516 208.587 116.81 211.293 115.457C212.195 115.006 213.323 114.78 214.45 114.78C215.578 114.78 216.705 115.006 217.607 115.457C220.539 116.81 222.117 119.741 222.117 122.673V137.105C222.117 145.899 222.117 149.733 220.088 153.115C218.284 155.821 215.578 157.4 210.391 160.106L206.332 162.361C203.175 164.165 199.793 165.969 196.861 167.547C193.93 169.126 190.322 171.155 187.39 172.734C185.361 173.41 183.557 174.763 182.204 176.567C181.302 179.048 181.076 181.528 181.302 184.009C181.302 185.362 181.302 187.617 181.302 190.097C181.302 191.901 181.302 193.931 181.302 195.735C181.302 202.049 181.302 202.725 192.577 207.235L197.312 209.039L200.695 210.392C206.107 212.422 209.264 214.677 210.842 217.834C212.421 220.991 212.646 224.373 212.646 229.334V323.142C212.421 338.025 209.489 342.535 206.783 346.82C204.528 350.428 202.273 354.036 202.273 365.536V392.371C200.695 392.822 198.891 392.822 197.087 392.371V365.536C197.087 352.457 199.793 348.398 202.273 344.114C204.754 340.28 207.234 336.447 207.46 322.917V229.109C207.685 225.952 207.46 223.02 206.332 220.089C205.205 218.059 203.175 216.706 198.891 214.902L195.508 213.549L190.773 211.745C176.566 206.108 176.566 204.98 176.341 195.735V190.097C176.341 187.617 176.341 185.587 176.341 184.009C176.115 180.626 176.566 177.244 177.919 174.087C179.498 171.381 181.978 169.351 184.91 167.998C187.841 166.42 190.998 164.841 194.381 163.037C197.763 161.233 201.146 159.429 203.852 157.851L207.911 155.596C212.195 153.341 214.676 151.988 215.578 150.409C216.931 148.38 216.931 144.772 216.931 137.105V122.447C216.931 121.32 216.48 120.192 215.352 119.741C214.901 119.516 214.676 119.516 214.225 119.516C213.774 119.516 213.548 119.516 213.097 119.741C212.195 120.192 211.744 121.32 211.744 122.447C211.744 124.702 211.744 127.183 211.744 129.438C211.97 131.693 211.97 133.722 211.97 135.977Z",
    fill: "#231F20"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.89 135.976H180.851V167.095C180.851 172.732 177.243 177.919 170.478 181.076L99.2199 217.381C85.6899 224.372 84.3369 233.843 84.3369 251.657V324.945C85.4644 340.955 97.6414 342.534 105.759 347.269C113.877 352.005 115.456 352.456 115.23 366.888C115.23 367.564 115.005 392.82 115.005 392.82H130.339V365.76C130.564 349.073 129.888 345.24 115.23 336.22C106.661 331.033 98.5434 330.131 98.5434 319.082V248.726C98.5434 239.931 97.6414 235.421 108.465 228.656L175.664 194.831C190.322 186.713 194.606 181.076 194.606 165.742V110.269V107.563C194.606 103.729 191.449 100.572 187.616 100.572H187.165H183.331C179.047 100.572 175.664 103.955 175.664 108.239V135.976H175.89Z",
    fill: "#C6E9FA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M175.89 135.976H180.851V167.095C180.851 172.732 177.243 177.919 170.478 181.076L99.2199 217.381C85.6899 224.372 84.3369 233.843 84.3369 251.657V324.945C85.4644 340.955 97.6414 342.534 105.759 347.269C113.877 352.005 115.456 352.456 115.23 366.888C115.23 367.564 115.005 392.82 115.005 392.82H130.339V365.76C130.564 349.073 129.888 345.24 115.23 336.22C106.661 331.033 98.5434 330.131 98.5434 319.082V248.726C98.5434 239.931 97.6414 235.421 108.465 228.656L175.664 194.831C190.322 186.713 194.606 181.076 194.606 165.742V110.269V107.563C194.606 103.729 191.449 100.572 187.616 100.572H187.165H183.331C179.047 100.572 175.664 103.955 175.664 108.239V135.976H175.89Z",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.674 392.596H161.007V332.162C161.007 316.828 165.517 312.769 179.949 304.651L247.148 270.826C257.972 264.061 257.07 259.325 257.07 250.531V181.753C257.07 170.929 249.177 168.674 240.834 163.037C226.402 153.34 225.274 153.115 225.274 136.428V120.643H233.167C233.167 121.094 232.941 132.143 232.941 132.82C232.941 147.252 231.814 148.154 242.863 155.37C245.118 156.948 249.628 159.88 252.334 161.458C259.099 165.517 264.286 169.802 264.511 179.273V247.825C264.511 265.414 263.158 270.826 249.628 277.816L178.145 313.896C172.056 317.053 167.997 323.142 167.772 329.907L168.674 392.596Z",
    fill: "#F48245"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M168.674 392.596H161.007V332.162C161.007 316.828 165.517 312.769 179.949 304.651L247.148 270.826C257.972 264.061 257.07 259.325 257.07 250.531V181.753C257.07 170.929 249.177 168.674 240.834 163.037C226.402 153.34 225.274 153.115 225.274 136.428V120.643H233.167C233.167 121.094 232.941 132.143 232.941 132.82C232.941 147.252 231.814 148.154 242.863 155.37C245.118 156.948 249.628 159.88 252.334 161.458C259.099 165.517 264.286 169.802 264.511 179.273V247.825C264.511 265.414 263.158 270.826 249.628 277.816L178.145 313.896C172.056 317.053 167.997 323.142 167.772 329.907L168.674 392.596Z",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.145 225.499L305.552 147.927C316.376 141.387 330.583 144.77 337.122 155.594C343.662 166.418 340.279 180.624 329.455 187.164L202.048 264.736C201.371 277.589 194.606 289.09 183.557 295.855C165.291 306.904 141.614 301.041 130.564 283.001L129.211 280.746C118.162 262.481 124.025 238.803 142.065 227.754C152.889 220.989 166.419 220.312 178.145 225.499Z",
    fill: "#0077AF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M178.145 225.499L305.552 147.927C316.376 141.387 330.583 144.77 337.122 155.594C343.662 166.418 340.279 180.624 329.455 187.164L202.048 264.736C201.371 277.589 194.606 289.09 183.557 295.855C165.291 306.904 141.614 301.041 130.564 283.001L129.211 280.746C118.162 262.481 124.025 238.803 142.065 227.754C152.889 220.989 166.419 220.312 178.145 225.499Z",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.027 225.501L297.434 147.929C307.807 140.487 322.239 142.742 329.681 153.115C337.122 163.488 334.867 177.92 324.494 185.362C323.592 186.038 322.465 186.715 321.563 187.166L194.155 264.738C193.479 277.591 186.714 289.092 175.664 295.857C157.399 306.906 133.721 301.043 122.672 283.003L121.319 280.748C110.269 262.483 115.907 238.805 134.172 227.756C144.771 220.991 158.526 220.089 170.027 225.501Z",
    fill: "#0094D9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M170.027 225.501L297.434 147.929C307.807 140.487 322.239 142.742 329.681 153.115C337.122 163.488 334.867 177.92 324.494 185.362C323.592 186.038 322.465 186.715 321.563 187.166L194.155 264.738C193.479 277.591 186.714 289.092 175.664 295.857C157.399 306.906 133.721 301.043 122.672 283.003L121.319 280.748C110.269 262.483 115.907 238.805 134.172 227.756C144.771 220.991 158.526 220.089 170.027 225.501Z",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.134 253.461L146.575 249.177L154.017 244.667L161.684 248.951L169.351 253.236V262.03V270.825L161.909 275.109L154.242 279.619L146.801 275.335L139.134 271.05V262.256V253.461Z",
    fill: "#C6E9FA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2415_35106",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 139,
    y: 244,
    width: 31,
    height: 36
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M139.134 253.462L146.576 249.178L154.017 244.668L161.684 248.952L169.351 253.237V262.031V270.826L161.91 275.11L154.243 279.62L146.801 275.336L139.134 271.051V262.257V253.462Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2415_35106)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.389 255.041L149.056 250.756L156.498 246.246L164.165 250.531L171.606 254.815V263.61L171.832 272.404L164.165 276.689L156.723 281.199L149.056 276.914L141.615 272.404V263.835L141.389 255.041Z",
    fill: "#DEF2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.389 255.041L149.056 250.756L156.498 246.246L164.165 250.531L171.606 254.815V263.61L171.832 272.404L164.165 276.689L156.723 281.199L149.056 276.914L141.615 272.404V263.835L141.389 255.041Z",
    stroke: "#231F20",
    strokeWidth: 4.80315,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M139.134 253.461L146.575 249.177L154.017 244.667L161.684 248.951L169.351 253.236V262.03V270.825L161.909 275.109L154.242 279.619L146.801 275.335L139.134 271.05V262.256V253.461Z",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.808 181.752L312.318 208.136C317.504 216.254 331.485 212.42 332.613 200.018C333.064 195.959 335.093 181.301 336.897 169.35C337.348 166.418 340.054 150.633 335.319 149.055C333.515 148.378 332.838 149.28 333.064 150.859C333.289 152.437 333.966 154.692 333.515 154.918C333.515 154.918 333.064 145.672 329.005 145.447C325.397 145.221 326.524 148.153 327.201 151.084C327.426 152.212 327.652 153.339 327.652 153.114C327.426 151.084 326.975 149.055 326.299 147.025C325.397 142.29 318.406 144.094 319.083 146.574C319.308 147.702 320.661 147.476 320.887 148.604C321.563 152.212 322.014 155.82 321.338 156.271C319.985 156.947 319.985 156.496 318.406 152.888C316.828 149.28 313.22 150.182 314.122 155.143C314.798 158.977 317.955 163.938 317.73 166.869L315.7 174.987L307.808 181.752Z",
    fill: "#E8C0A8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M307.808 181.752L312.318 208.136C317.504 216.254 331.485 212.42 332.613 200.018C333.064 195.959 335.093 181.301 336.897 169.35C337.348 166.418 340.054 150.633 335.319 149.055C333.515 148.378 332.838 149.28 333.064 150.859C333.289 152.437 333.966 154.692 333.515 154.918C333.515 154.918 333.064 145.672 329.005 145.447C325.397 145.221 326.524 148.153 327.201 151.084C327.426 152.212 327.652 153.339 327.652 153.114C327.426 151.084 326.975 149.055 326.299 147.025C325.397 142.29 318.406 144.094 319.083 146.574C319.308 147.702 320.661 147.476 320.887 148.604C321.563 152.212 322.014 155.82 321.338 156.271C319.985 156.947 319.985 156.496 318.406 152.888C316.828 149.28 313.22 150.182 314.122 155.143C314.798 158.977 317.955 163.938 317.73 166.869L315.7 174.987L307.808 181.752Z",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.964 157.851C287.287 153.792 289.091 150.635 292.474 149.959C293.376 149.733 294.278 149.959 294.729 150.635L296.759 164.616C297.21 167.999 289.994 168.675 288.866 165.969L287.964 157.851Z",
    fill: "#E8C0A8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M287.964 157.851C287.287 153.792 289.091 150.635 292.474 149.959C293.376 149.733 294.278 149.959 294.729 150.635L296.759 164.616C297.21 167.999 289.994 168.675 288.866 165.969L287.964 157.851Z",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.022 226.402C267.895 228.883 237.678 345.466 234.972 353.359H355.389C354.938 352.231 336.447 310.965 328.78 295.856C327.652 292.925 327.427 289.768 328.103 286.836C331.486 263.61 331.26 243.089 315.926 226.402H269.022Z",
    fill: "#E8412A",
    stroke: "black",
    strokeWidth: 1.2177,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M297.434 259.776L286.385 265.864L275.11 261.129C275.335 260.227 275.11 241.285 274.659 238.128H296.758L297.434 259.776Z",
    stroke: "white",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M328.554 264.963L326.524 266.316L315.926 261.58C315.7 260.678 310.514 241.736 309.386 238.579H322.465",
    stroke: "white",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.493 140.262C279.62 137.782 281.65 135.752 284.356 134.85C290.219 133.723 295.856 135.527 297.209 142.743C297.66 148.155 294.954 153.341 290.219 156.047C283.003 159.43 276.689 154.469 276.689 147.478C276.689 146.802 276.238 146.125 276.238 145.449C276.238 144.772 277.14 144.547 277.14 144.321C277.14 142.968 277.816 141.615 278.493 140.262Z",
    fill: "#F9D1E3"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M278.493 140.262C279.62 137.782 281.65 135.752 284.356 134.85C290.219 133.723 295.856 135.527 297.209 142.743C297.66 148.155 294.954 153.341 290.219 156.047C283.003 159.43 276.689 154.469 276.689 147.478C276.689 146.802 276.238 146.125 276.238 145.449C276.238 144.772 277.14 144.547 277.14 144.321C277.14 142.968 277.816 141.615 278.493 140.262Z",
    fill: "#E8C0A8",
    stroke: "black",
    strokeWidth: 1.2177,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.258 154.467C306.003 140.26 303.973 131.466 292.022 131.466C282.551 131.466 278.717 139.133 279.168 139.133H280.296L282.776 154.467H308.258Z",
    fill: "#683914"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M308.258 154.467C306.003 140.26 303.973 131.466 292.022 131.466C282.551 131.466 278.717 139.133 279.168 139.133H280.296L282.776 154.467H308.258Z",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.472 227.303C284.806 227.303 300.14 227.754 315.474 227.303C315.7 227.303 308.033 184.458 308.258 184.458C308.484 184.458 318.857 184.458 318.857 184.458C318.857 184.458 313.219 167.094 309.16 162.81C305.101 158.525 299.013 158.525 296.307 163.035C296.983 168.898 289.091 167.094 288.865 165.065C288.189 160.104 281.649 158.525 277.816 161.457C274.208 163.937 270.6 170.026 268.345 173.859C266.09 177.467 264.06 181.075 262.256 184.683H278.267L269.472 227.303Z",
    fill: "#F8BDB4"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M269.472 227.303C284.806 227.303 300.14 227.754 315.474 227.303C315.7 227.303 308.033 184.458 308.258 184.458C308.484 184.458 318.857 184.458 318.857 184.458C318.857 184.458 313.219 167.094 309.16 162.81C305.101 158.525 299.013 158.525 296.307 163.035C296.983 168.898 289.091 167.094 288.865 165.065C288.189 160.104 281.649 158.525 277.816 161.457C274.208 163.937 270.6 170.026 268.345 173.859C266.09 177.467 264.06 181.075 262.256 184.683H278.267L269.472 227.303Z",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.031 184.459H278.041L273.757 206.107C271.051 223.921 263.609 234.745 244.667 226.402C237 223.019 213.548 211.97 212.646 211.97C206.107 211.519 202.724 207.911 203.626 203.852C203.852 202.724 204.754 201.822 206.107 201.597C205.205 195.283 210.391 197.538 210.391 197.087C209.94 195.508 210.842 193.704 212.421 193.253C213.548 192.802 214.676 193.253 215.578 194.155C216.48 195.057 217.382 195.959 218.509 196.636C219.186 195.959 215.803 195.508 216.254 194.155C217.833 188.067 225.5 192.577 228.882 194.381C236.098 197.989 248.275 204.979 250.981 206.558L262.031 184.459Z",
    fill: "#E8C0A8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M262.031 184.459H278.041L273.757 206.107C271.051 223.921 263.609 234.745 244.667 226.402C237 223.019 213.548 211.97 212.646 211.97C206.107 211.519 202.724 207.911 203.626 203.852C203.852 202.724 204.754 201.822 206.107 201.597C205.205 195.283 210.391 197.538 210.391 197.087C209.94 195.508 210.842 193.704 212.421 193.253C213.548 192.802 214.676 193.253 215.578 194.155C216.48 195.057 217.382 195.959 218.509 196.636C219.186 195.959 215.803 195.508 216.254 194.155C217.833 188.067 225.5 192.577 228.882 194.381C236.098 197.989 248.275 204.979 250.981 206.558L262.031 184.459Z",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M278.041 184.91L279.169 179.724",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M313.444 213.772L307.356 179.496",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M250.981 206.557L248.952 210.841",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M210.391 197.088C210.617 199.794 212.646 201.823 215.127 202.5",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M206.107 201.822C206.783 202.499 207.234 206.107 211.068 206.332",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M295.856 354.26L301.719 278.041C304.425 276.688 306.455 274.658 307.582 271.952",
    stroke: "white",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.663 373.88L347.27 338.025L298.787 353.134C304.199 366.213 295.856 372.527 294.052 373.654C292.248 374.782 280.071 376.811 277.139 385.831C276.688 388.086 276.688 390.341 276.914 392.822H307.131L331.71 385.155L334.416 378.164L338.024 383.125L366.663 373.88Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M366.663 373.88L347.27 338.025L298.787 353.134C304.199 366.213 295.856 372.527 294.052 373.654C292.248 374.782 280.071 376.811 277.139 385.831C276.688 388.086 276.688 390.341 276.914 392.822H307.131L331.71 385.155L334.416 378.164L338.024 383.125L366.663 373.88Z",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M276.689 385.831H304.651L363.056 368.017",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.544 346.594C338.25 345.918 340.956 347.271 341.633 349.977C342.535 352.683 340.956 355.614 338.476 356.516C335.77 357.193 333.064 355.84 332.162 353.134C331.26 350.202 332.838 347.496 335.544 346.594Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M335.544 346.594C338.25 345.918 340.956 347.271 341.633 349.977C342.535 352.683 340.956 355.614 338.476 356.516C335.77 357.193 333.064 355.84 332.162 353.134C331.26 350.202 332.838 347.496 335.544 346.594Z",
    fill: "#0094D9"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M292.249 374.103C296.759 372.525 304.426 380.192 304.651 385.829",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M302.396 378.84C310.063 373.879 313.896 359.898 308.258 347.946",
    stroke: "#231F20",
    strokeWidth: 1.51085,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.346 392.821L294.728 352.682H246.471C245.795 355.613 245.569 359.447 236.324 365.986C232.265 368.918 224.372 371.398 218.284 374.781C211.744 378.389 207.46 385.379 207.46 392.821H256.168L262.256 386.958L262.707 392.821H291.346Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M291.346 392.821L294.728 352.682H246.471C245.795 355.613 245.569 359.447 236.324 365.986C232.265 368.918 224.372 371.398 218.284 374.781C211.744 378.389 207.46 385.379 207.46 392.821H256.168L262.256 386.958L262.707 392.821H291.346Z",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M208.588 385.83H291.572",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.071 357.193C282.777 357.193 285.032 359.448 285.032 362.154C285.032 362.154 285.032 362.154 285.032 362.38C285.032 365.311 282.777 367.566 279.846 367.566C277.14 367.566 274.885 365.311 274.885 362.605C274.885 362.605 274.885 362.605 274.885 362.38C275.11 359.448 277.365 357.193 280.071 357.193Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M280.071 357.193C282.777 357.193 285.032 359.448 285.032 362.154C285.032 362.154 285.032 362.154 285.032 362.38C285.032 365.311 282.777 367.566 279.846 367.566C277.14 367.566 274.885 365.311 274.885 362.605C274.885 362.605 274.885 362.605 274.885 362.38C275.11 359.448 277.365 357.193 280.071 357.193Z",
    fill: "#0094D9"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M228.207 370.045C231.138 370.27 234.972 381.094 233.844 385.83",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M233.167 376.36C242.638 374.331 256.168 363.507 259.099 352.457",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M318.857 184.459L322.014 192.577",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.659 141.164C276.914 136.428 276.237 140.487 277.139 133.948C277.816 127.408 282.777 122.222 289.091 121.32C301.493 119.741 304.425 131.016 306.905 140.713L306.68 141.164H274.659Z",
    fill: "#FFCA05"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M274.659 141.164C276.914 136.428 276.237 140.487 277.139 133.948C277.816 127.408 282.777 122.222 289.091 121.32C301.493 119.741 304.425 131.016 306.905 140.713L306.68 141.164H274.659Z",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M276.463 137.779H297.209",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M286.61 141.162H283.679V157.173H286.61V141.162Z",
    fill: "#FFCA05"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M286.61 141.162H283.679V157.173H286.61V141.162Z",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M157.174 215.804C165.743 216.029 178.597 219.863 184.911 225.726",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M175.214 215.129C179.498 216.482 183.557 218.511 187.165 220.766",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M194.156 264.737L202.274 264.963",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M174.086 342.984H169.576",
    stroke: "#231F20",
    strokeWidth: 1.19515,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M173.635 177.92H169.125",
    stroke: "#231F20",
    strokeWidth: 1.19515,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7689 248.726H84.3369",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7689 314.121H84.3369",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M113.201 210.392L119.515 223.245",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M166.194 183.557L172.734 196.636",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M181.076 157.851H195.057",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M115.231 368.917H130.339",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.84 101.251C147.703 101.251 152.438 105.986 152.438 111.849V130.115H131.241V111.849C131.241 106.212 135.977 101.251 141.84 101.251Z",
    fill: "#FF0000"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M141.84 101.251C147.703 101.251 152.438 105.986 152.438 111.849V130.115H131.241V111.849C131.241 106.212 135.977 101.251 141.84 101.251Z",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M138.231 130.339L143.868 120.643C145.672 117.486 144.996 114.554 142.29 114.554C140.035 114.329 138.005 116.809 140.035 120.643L145.221 130.339",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M155.369 130.339H127.407V135.976H155.369V130.339Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M155.369 130.339H127.407V135.976H155.369V130.339Z",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M126.956 113.201C126.731 109.142 128.084 105.308 130.79 102.151",
    stroke: "#FF0000",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M122.446 113.651C122.221 108.239 124.025 102.827 127.633 98.543",
    stroke: "#FF0000",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M117.936 114.554C117.936 107.338 119.74 99.8965 124.926 94.71",
    stroke: "#FF0000",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M156.046 113.201C156.272 109.142 154.919 105.308 152.213 102.151",
    stroke: "#FF0000",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M160.556 113.651C160.781 108.014 158.977 102.602 155.369 98.543",
    stroke: "#FF0000",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M165.292 114.554C165.743 107.338 163.262 100.122 158.301 94.71",
    stroke: "#FF0000",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M181.076 135.977V114.329",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.952 114.329L263.61 136.202H255.266L243.089 118.162C238.354 112.525 233.618 116.358 233.618 120.868H225.5C225.5 118.613 226.176 116.358 227.078 114.329C230.912 106.887 241.962 103.73 248.952 114.329Z",
    fill: "#F48245"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M248.952 114.329L263.61 136.202H255.266L243.089 118.162C238.354 112.525 233.618 116.358 233.618 120.868H225.5C225.5 118.613 226.176 116.358 227.078 114.329C230.912 106.887 241.962 103.73 248.952 114.329Z",
    stroke: "#231F20",
    strokeWidth: 1.28535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIllustration);
export default __webpack_public_path__ + "static/media/LoginIllustration.a777f814f2ce5aeeddc59cacd1703b9e.svg";
export { ForwardRef as ReactComponent };